import React from "react";

const PlayIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="lucide lucide-play"
    >
      <polygon points="6 3 20 12 6 21 6 3"></polygon>
    </svg>
  );
};

export default PlayIcon;
